module.exports = __webpack_public_path__ + "img/contact-gustavholmquist.26939050.png";